import { render, staticRenderFns } from "./acquista-una-card.vue?vue&type=template&id=6b9374ae"
import script from "./acquista-una-card.vue?vue&type=script&lang=js"
export * from "./acquista-una-card.vue?vue&type=script&lang=js"
import style0 from "./acquista-una-card.vue?vue&type=style&index=0&id=6b9374ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports